var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContributionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6012 17.3492C3.10627 25.1003 7.35904 24.2883 7.35904 27.9388C7.35904 31.5894 14.4136 30.5434 16.2082 30.5476C18.2371 30.5476 23.3153 31.224 23.7138 28.62C24.1122 26.016 26.1835 26.1326 26.1835 22.602C26.1835 20.6512 25.6342 17.8224 24.6875 16.0824C22.944 12.8783 19.8298 10.4697 16.2082 10.4697C11.8449 10.4697 7.97485 13.2435 6.6012 17.3492Z",
    fill: "#FCBF1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1752:4986",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 7,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6758 0.991211H19.3065V6.8443H13.6758V0.991211Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1752:4986)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8028 0.988281C14.1819 0.988281 13.6758 1.57844 13.6758 2.10536C13.6758 3.30254 14.8198 5.61258 15.4747 6.84348H17.5075C18.1625 5.61258 19.3065 3.30254 19.3065 2.10536C19.3065 1.57844 18.8004 0.988281 18.1795 0.988281H14.8028Z",
    fill: "#FCBF1E"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3028 2.10449C9.68186 2.10449 9.17578 2.69465 9.17578 3.22157C9.17578 4.33865 11.132 5.89412 12.4674 6.8468H14.3769C14.2238 6.54751 14.1047 6.33674 13.9133 5.94049C13.3307 4.71382 12.6928 3.37332 12.6928 2.10449H10.3028Z",
    fill: "#FECA40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2814 2.10449C20.2814 3.37332 19.6477 4.71382 19.0651 5.94049C18.878 6.33674 18.7589 6.54751 18.6016 6.8468H20.511C21.8422 5.89412 23.8027 4.33865 23.8027 3.22157C23.8027 2.69465 23.2966 2.10449 22.6757 2.10449H20.2814Z",
    fill: "#F9C94B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.111 7.68023C12.4901 7.68023 11.9883 8.17765 11.9883 8.79732C11.9883 9.41277 12.4901 9.91019 13.111 9.91019H13.2046C14.1614 9.64462 15.1608 9.49286 16.2028 9.49286C17.2405 9.49286 18.2484 9.64462 19.201 9.91019H19.303C19.924 9.91019 20.4258 9.41277 20.4258 8.79732C20.4258 8.17765 19.924 7.68023 19.303 7.68023H13.111Z",
    fill: "#120136"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4863 3.76875C3.19711 3.80248 2.98021 4.04697 2.98872 4.33784V4.87319C2.95895 5.18092 3.19285 5.45071 3.49905 5.476C3.80951 5.50129 4.08169 5.27366 4.10721 4.96593C4.11146 4.93643 4.11146 4.90692 4.10721 4.87319V4.33784C4.11571 4.03011 3.86905 3.77297 3.56285 3.76875C3.53733 3.76875 3.51181 3.76875 3.4863 3.76875Z",
    fill: "#120136"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4863 6.56074C3.20136 6.59446 2.98447 6.83474 2.98872 7.12138V7.66517C2.95895 7.97289 3.19285 8.24268 3.49905 8.26797C3.80951 8.29326 4.08169 8.06563 4.10721 7.75791C4.11146 7.7284 4.11146 7.69889 4.10721 7.66517V7.12138C4.11146 6.81366 3.86054 6.56074 3.55009 6.56074C3.52882 6.56074 3.50756 6.56074 3.4863 6.56074Z",
    fill: "#120136"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62637 5.44019C4.31592 5.45705 4.07351 5.7184 4.09053 6.03034C4.10754 6.33806 4.37121 6.57834 4.68591 6.56148H5.23451C5.54497 6.56148 5.79588 6.31277 5.79588 6.00083C5.79588 5.69311 5.54497 5.44019 5.23451 5.44019H4.68591H4.62637Z",
    fill: "#120136"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80997 5.44019C1.49951 5.45705 1.25711 5.7184 1.27412 6.03034C1.29113 6.33806 1.5548 6.57834 1.8695 6.56148H2.41811C2.72856 6.56148 2.97947 6.31277 2.97947 6.00083C2.97947 5.69311 2.72856 5.44019 2.41811 5.44019H1.8695H1.80997Z",
    fill: "#120136"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11174 10.4698C4.11174 10.7776 3.86083 11.0305 3.55037 11.0305C3.23567 11.0305 2.98476 10.7776 2.98476 10.4698C2.98476 10.1621 3.23567 9.91341 3.55037 9.91341C3.86083 9.91341 4.11174 10.1621 4.11174 10.4698Z",
    fill: "#120136"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7975 13.8146C5.7975 14.1223 5.54233 14.3752 5.23187 14.3752C4.92142 14.3752 4.66625 14.1223 4.66625 13.8146C4.66625 13.5068 4.92142 13.2581 5.23187 13.2581C5.54233 13.2581 5.7975 13.5068 5.7975 13.8146Z",
    fill: "#120136"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1052 27.7627C30.7947 27.7712 30.5481 28.0241 30.5566 28.3318V28.8756C30.5311 29.1791 30.7607 29.4489 31.0669 29.4742C31.3774 29.4995 31.6538 29.2718 31.6793 28.9641C31.6835 28.9346 31.6835 28.9051 31.6793 28.8756V28.3318C31.6835 28.0241 31.4369 27.7669 31.1264 27.7627H31.1052Z",
    fill: "#120136"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0478 24.981C30.7671 25.0189 30.5544 25.255 30.5587 25.5416V26.0854C30.5332 26.3889 30.7628 26.6587 31.069 26.684C31.3795 26.7093 31.6559 26.4816 31.6772 26.1739C31.6814 26.1444 31.6814 26.1149 31.6772 26.0854V25.5416C31.6814 25.2339 31.4348 24.981 31.1243 24.9767C31.0988 24.9767 31.0733 24.9767 31.0478 24.981Z",
    fill: "#120136"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3768 26.6525C29.0706 26.6904 28.8495 26.9644 28.8835 27.2679C28.9175 27.5504 29.1514 27.7611 29.4364 27.7653H29.985C30.2912 27.7906 30.5634 27.563 30.5889 27.2553C30.6186 26.9475 30.3847 26.6778 30.0785 26.6525C30.0445 26.6483 30.0105 26.6483 29.985 26.6525H29.4364C29.4151 26.6483 29.3981 26.6483 29.3768 26.6525Z",
    fill: "#120136"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1932 26.6525C31.887 26.6904 31.6659 26.9644 31.6999 27.2679C31.7339 27.5504 31.9679 27.7611 32.2528 27.7653H32.8014C33.1076 27.7906 33.3798 27.563 33.4053 27.2553C33.435 26.9475 33.2011 26.6778 32.8949 26.6525C32.8609 26.6483 32.8269 26.6483 32.8014 26.6525H32.2528C32.2315 26.6483 32.2145 26.6483 32.1932 26.6525Z",
    fill: "#120136"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3012 23.2973C28.3012 22.9896 28.5564 22.7367 28.8668 22.7367C29.173 22.7367 29.4282 22.9896 29.4282 23.2973C29.4282 23.6008 29.173 23.8537 28.8668 23.8537C28.5564 23.8537 28.3012 23.605 28.3012 23.2973Z",
    fill: "#120136"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.46 12.1431H29.1441C29.3057 12.1431 29.4291 12.2654 29.4291 12.4214V14.0949C29.4291 14.2508 29.3057 14.3731 29.1441 14.3731H27.46C27.3069 14.3731 27.1793 14.2508 27.1793 14.0949V12.4214C27.1793 12.2654 27.3069 12.1431 27.46 12.1431ZM28.3021 9.91309C26.4309 9.91309 24.9297 11.4011 24.9297 13.2559C24.9297 13.4371 24.9552 13.61 24.985 13.787C25.5038 14.4488 25.9503 15.1739 26.3076 15.9495C26.8647 16.3584 27.5494 16.6071 28.3021 16.6071C30.1733 16.6071 31.683 15.1107 31.683 13.2559C31.683 11.4011 30.1733 9.91309 28.3021 9.91309Z",
    fill: "#E9A900"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContributionIcon);
export default __webpack_public_path__ + "static/media/contribution-icon.dd9da817.svg";
export { ForwardRef as ReactComponent };